module.exports = __webpack_public_path__ + "img/9788934974642.2241e5ec.jpg";